import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';

interface AuthOverlayProps {
  children: React.ReactNode;
}

export const AuthOverlay = ({ children }: AuthOverlayProps) => {
  const { authInProgress } = useAuth();
  const [showOverlay, setShowOverlay] = useState(false);
  
  // Add a slight delay before showing the overlay to prevent flashing
  useEffect(() => {
    let timeout: number;
    
    if (authInProgress) {
      timeout = window.setTimeout(() => {
        setShowOverlay(true);
      }, 100); // Small delay to prevent flashing for quick operations
    } else {
      setShowOverlay(false);
    }
    
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [authInProgress]);

  return (
    <>
      {children}
      
      <AnimatePresence>
        {showOverlay && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 z-[9999] bg-white/90 backdrop-blur-sm flex items-center justify-center will-change-transform"
          >
            <div className="flex flex-col items-center">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600 mb-4"></div>
              <p className="text-gray-600 font-medium">Loading...</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default AuthOverlay;